import { ChangeEvent } from "react";

import { Client } from "@/Common/Api/Client";
import { MyleDSQEmployeeResponse } from "@/Common/Api/Dsq/Dto/Responses/MyleDSQEmployeeResponse";
import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { Popup } from "@/Common/Components/Modals/Popup";
import { PermitType } from "@/Common/Models/DSQ/PermitType";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { DateSelector } from "../Inputs/DateSelector";

import img_loading from "@/Globals/_images/loading.gif";

interface IDSQEmployeeComponent {
    onCloseCallback: () => void;
    updateEmployeeCallback: (employee: Employee) => void;
    employeeModel: Employee;
}

class DSQEmployeeComponentState {
    public isLoading: boolean;
    public FirstName: string;
    public LastName: string;
    public IsMaleChecked: boolean;
    public IsFemaleChecked: boolean;
    public Gender: string;
    public LicenceNumber: string;
    public SelectedType: string;
    public PermitType: PermitType;
    public showEmployeeSelectionPopup: boolean;
    public employeeResults: Employee[];
    public dateOfBirth?: Date;
}

class DSQEmployeeComponent extends BaseReactComponent<IDSQEmployeeComponent, DSQEmployeeComponentState> {
    public constructor(props: IDSQEmployeeComponent) {
        super(props);
        let initialState = new DSQEmployeeComponentState();

        if (props.employeeModel.FirstNameDSQ != null)
            initialState.FirstName = props.employeeModel.FirstNameDSQ.toTitleCase();
        if (props.employeeModel.LastNameDSQ != null)
            initialState.LastName = props.employeeModel.LastNameDSQ.toTitleCase();

        initialState.LicenceNumber = props.employeeModel.LicenceDSQ;

        if (props.employeeModel.GenderLookupId && cacheStore.GetLookupById(props.employeeModel.GenderLookupId).LookupCode === "MALE") {
            initialState.Gender = "M";
            initialState.IsMaleChecked = true;
        }
        else if (props.employeeModel.GenderLookupId && cacheStore.GetLookupById(props.employeeModel.GenderLookupId).LookupCode === "FEMALE") {
            initialState.Gender = "F";
            initialState.IsFemaleChecked = true;
        }

        // Initialize a new permit here so if the user don't change anything, it will not crash
        const newPermit = new PermitType();

        newPermit.Permit = 1;
        newPermit.PermitName = "Collège des médecins du Québec";
        newPermit.DSQRoot = "2.16.840.1.113883.4.288";

        initialState.PermitType = newPermit;
        initialState.SelectedType = "Collège des médecins du Québec";

        this.state = initialState;
    }

    public componentDidMount(): void {
        this.setOverlay("DSQEmployeeComponent");
    }

    public render(): JSX.Element {
        let self = this;
        var typeDictionnaries: { [id: string]: string } = {};

        typeDictionnaries["0"] = "Collège des médecins du Québec";
        typeDictionnaries["1"] = "Ordre des pharmaciens du Québec";
        typeDictionnaries["2"] = "Ordre des optométristes du Québec";
        typeDictionnaries["3"] = "Ordre des podiatres du Québec";
        typeDictionnaries["4"] = "Ordre des sages-femmes du Québec";
        typeDictionnaries["5"] = "Ordre des dentistes du Québec";
        typeDictionnaries["6"] = "Ordre des infirmières et infirmiers du Québec";
        typeDictionnaries["7"] = "Infirmière et infirmier auxiliaire du Québec";

        let employeeSelectionPopup: JSX.Element = (

            <Popup Id="dsqLocation" title="Sites DSQ correspondants" onCloseDelegate={() => self.mutateState(s => s.showEmployeeSelectionPopup = false)} draggable={true} cssClass="memo">

                <div className="p-body" style={{ maxHeight: "550px", overflow: "auto" }}>
                    {self.state.employeeResults != null && self.state.employeeResults.length > 0
                        && self.state.employeeResults.map((emp, i) => {
                            Object.keys(typeDictionnaries).map(x => {
                                if (x === self.getEmployeeType(emp.LicenceRoot))
                                    emp.Type = +x;
                            });
                            console.log(emp.LastNameDSQ.toTitleCase() + ", " + emp.FirstNameDSQ.toTitleCase() + " (" + emp.LicenceDSQ + ")");

                            return (
                                <div key={"location_" + i} className="DSQ-location-search-item">
                                    <div style={{ float: "left", width: "80%" }}>
                                        <p>{emp.LastNameDSQ.toTitleCase() + ", " + emp.FirstNameDSQ.toTitleCase() + " (" + emp.LicenceDSQ + ")"}  </p>
                                        <p>{typeDictionnaries[emp.Type.toString()]}</p>
                                    </div>
                                    <a style={{ float: "right" }} onClick={() => self.syncSelectedEmployee(emp)}>{cacheStore.GetString("btnSynchroniserDSQ")}</a>
                                </div>
                            );
                        })
                    }

                </div>
                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <div>
                                    <ButtonControl label={cacheStore.GetString("CloseLabel")} className="btn btn-default push-right-5" onClick={() => self.mutateState(s => s.showEmployeeSelectionPopup = false)} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );

        return (
            <div className="dsq-employee-popup">
                <div className="dep-header">
                    <h4>{cacheStore.GetString("lblSynchronizationDSQ")}</h4>
                </div>
                <div className="dep-main">
                    <div className="row">
                        <div className="col-sm-4 col-md-4 col-lg-4 text-right">
                            <label className="label-input">{cacheStore.GetString("SexAtBirthLabel")}</label>
                        </div>
                        <div className="col-sm-8 col-md-8 col-lg-8">
                            <div>
                                <label style={{ marginRight: "5px" }}>
                                    {cacheStore.GetString("ManLabel")}
                                    <input type="radio" style={{ marginLeft: "2px" }} checked={this.state.IsMaleChecked} onClick={this.onMaleClick.bind(this)} />
                                </label>
                                <label style={{ marginRight: "4px" }}>
                                    {cacheStore.GetString("WomanLabel")}
                                    <input type="radio" style={{ marginLeft: "2px" }} checked={this.state.IsFemaleChecked} onClick={this.onFemaleClick.bind(this)} />
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4 col-md-4 col-lg-4 text-right">
                            <label className="label-input">{cacheStore.GetString("FirstNameLabel")}</label>
                        </div>
                        <div className="col-sm-8 col-md-8 col-lg-8">
                            <input className="form-control" value={self.state.FirstName} type="text" onChange={this.onFirstNameChange.bind(this)} />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-4 col-md-4 col-lg-4 text-right">
                            <label className="label-input">{cacheStore.GetString("LastNameLabel")}</label>
                        </div>
                        <div className="col-sm-8 col-md-8 col-lg-8">
                            <input className="form-control" value={self.state.LastName} type="text" onChange={this.onLastNameChange.bind(this)} />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-4 col-md-4 col-lg-4 text-right">
                            <label className="label-input">{cacheStore.GetString("DateofBirthLabel")}</label>
                        </div>
                        <div className="col-sm-8 col-md-8 col-lg-8">
                            <DateSelector
                                id="dsq_dob_selector"
                                maxDate={new Date()}
                                autoComplete="off"
                                dateFormat="yyyy/MM/dd"
                                onChangeCallback={date => this.mutateState(s => s.dateOfBirth = date)}
                                date={this.state.dateOfBirth}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-4 col-md-4 col-lg-4 text-right">
                            <label className="label-input">{cacheStore.GetString("TypeLabel")}</label>
                        </div>
                        <div className="col-sm-8 col-md-8 col-lg-8">
                            <select className="form-control myle-control minimal" onChange={this.onTypeChange.bind(this)}>
                                {Object.keys(typeDictionnaries).map(x => (
                                    <option key={x} value={x}>{typeDictionnaries[x]}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-4 col-md-4 col-lg-4 text-right">
                            <label className="label-input">{cacheStore.GetString("PermitNumberLabel")}</label>
                        </div>
                        <div className="col-sm-8 col-md-8 col-lg-8">
                            <input className="form-control" value={this.state.LicenceNumber} type="text" onChange={this.onLicenseChange.bind(this)} />
                        </div>
                    </div>
                </div>
                <div className="dep-footer">
                    <div className="row">
                        <div className="col-lg-9 col-md-9 col-sm-9">
                            {this.state.isLoading && <img src={img_loading} alt="loading" />}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 text-right">
                            <div className="flex-container" style={{ justifyContent: "flex-end" }}>
                                <button className="btn btn-default push-right-5" disabled={this.state.isLoading} onClick={() => this.props.onCloseCallback()}>{cacheStore.GetString("CloseLabel")}</button>
                                <button className="btn btn-primary" disabled={this.state.isLoading} onClick={this.onProviderSearch.bind(this)}>{cacheStore.GetString("btnSynchroniserDSQ")}</button>
                            </div>
                        </div>
                    </div>
                </div>
                {self.state != null && self.state.employeeResults != null && self.state.showEmployeeSelectionPopup === true
                    && employeeSelectionPopup
                }

            </div>
        );
    }

    private onMaleClick(): void {
        var s = new DSQEmployeeComponentState();
        s.IsMaleChecked = true;
        s.IsFemaleChecked = false;

        s.Gender = "M";

        this.setState(s);
    }

    private onFemaleClick(): void {
        var s = new DSQEmployeeComponentState();
        s.IsMaleChecked = false;
        s.IsFemaleChecked = true;

        s.Gender = "F";

        this.setState(s);
    }

    private onFirstNameChange(e: ChangeEvent<HTMLInputElement>): void {
        var s = new DSQEmployeeComponentState();
        s.FirstName = e.target.value;
        this.setState(s);
    }

    private onLastNameChange(e: ChangeEvent<HTMLInputElement>): void {
        var s = new DSQEmployeeComponentState();
        s.LastName = e.target.value;
        this.setState(s);
    }

    private onLicenseChange(e: ChangeEvent<HTMLInputElement>): void {
        var s = new DSQEmployeeComponentState();
        s.LicenceNumber = e.target.value;
        this.setState(s);
    }

    private onTypeChange(e: ChangeEvent<HTMLSelectElement>): void {
        var s = new DSQEmployeeComponentState();

        var newPermit: PermitType;
        switch (e.target.value) {
            case "0":
                newPermit = new PermitType();

                newPermit.Permit = 1;
                newPermit.PermitName = "Collège des médecins du Québec";
                newPermit.DSQRoot = "2.16.840.1.113883.4.288";

                s.PermitType = newPermit;
                s.SelectedType = "Collège des médecins du Québec";

                break;

            case "1":
                newPermit = new PermitType();

                newPermit.Permit = 2;
                newPermit.PermitName = "Ordre des pharmaciens du Québec";
                newPermit.DSQRoot = "2.16.840.1.113883.4.298";

                s.PermitType = newPermit;
                s.SelectedType = "Ordre des pharmaciens du Québec";
                break;

            case "2":
                newPermit = new PermitType();

                newPermit.Permit = 3;
                newPermit.PermitName = "Ordre des optométristes du Québec";
                newPermit.DSQRoot = "2.16.840.1.113883.4.299";

                s.PermitType = newPermit;
                s.SelectedType = "Ordre des optométristes du Québec";
                break;

            case "3":
                newPermit = new PermitType();

                newPermit.Permit = 4;
                newPermit.PermitName = "Ordre des podiatres du Québec";
                newPermit.DSQRoot = "2.16.840.1.113883.4.300";

                s.PermitType = newPermit;
                s.SelectedType = "Ordre des podiatres du Québec";
                break;

            case "4":
                newPermit = new PermitType();

                newPermit.Permit = 5;
                newPermit.PermitName = "Ordre des sages-femmes du Québec";
                newPermit.DSQRoot = "2.16.840.1.113883.4.301";

                s.PermitType = newPermit;
                s.SelectedType = "Ordre des sages-femmes du Québec";
                break;

            case "5":
                newPermit = new PermitType();

                newPermit.Permit = 6;
                newPermit.PermitName = "Ordre des dentistes du Québec";
                newPermit.DSQRoot = "2.16.840.1.113883.4.302";

                s.PermitType = newPermit;
                s.SelectedType = "Ordre des dentistes du Québec";
                break;

            case "6":
                newPermit = new PermitType();

                newPermit.Permit = 7;
                newPermit.PermitName = "Ordre des infirmières et infirmiers du Québec";
                newPermit.DSQRoot = "2.16.840.1.113883.4.303";

                s.PermitType = newPermit;
                s.SelectedType = "Ordre des infirmières et infirmiers du Québec";
                break;

            case "7":
                newPermit = new PermitType();

                newPermit.Permit = 8;
                newPermit.PermitName = "Infirmière et infirmier auxiliaire du Québec";
                newPermit.DSQRoot = "2.16.124.10.101.1.60.202";

                s.PermitType = newPermit;
                s.SelectedType = "Infirmière et infirmier auxiliaire du Québec";
                break;

            default:
                break;
        }

        this.setState(s);
    }

    private onProviderSearch(): void {
        let requestData = {
            PermitNumder: this.state.LicenceNumber,
            PermitTypeCode: this.state.PermitType.Permit,
            FirstName: this.state.FirstName,
            LastName: this.state.LastName,
            Gender: this.state.Gender,
            ContactFacetId: this.props.employeeModel.ContactFacet_id,
            Employee: null,
            DateOfBirth: this.state.dateOfBirth
        };

        // Calls the provider search. It will also sync the employee automatically if only one is returned.
        this.mutateState(s => s.isLoading = true);
        let client = new Client();
        client.PostDSQ(
            ServerOperations.Server.DSQ_SynchroniseEmployee,
            requestData,
            response => {
                this.mutateState(
                    s => s.isLoading = false,
                    () => {
                        let employees: Employee[] = response.Employees && response.Employees.map(x => {
                            let emp = new Employee();
                            emp.FirstNameDSQ = x.FirstName;
                            emp.LastNameDSQ = x.LastName;
                            emp.LicenceDSQ = x.LicenceNumber;
                            emp.LicenceRoot = x.LicenceRoot;
                            emp.NUI = x.NUI;

                            return emp;
                        });

                        if (!employees || !employees.any())
                            return;

                        if (employees.length === 1) {
                            this.props.updateEmployeeCallback(employees.firstOrDefault());
                            return;
                        }

                        this.mutateState(s => {
                            s.showEmployeeSelectionPopup = true;
                            s.employeeResults = employees;
                        });
                    }
                );
            },
            () => this.mutateState(s => s.isLoading = false)
        );
    }

    // This is called in the case where the employee search provides more than one employee to choose from
    private syncSelectedEmployee(employee: Employee): void {
        let self = this;

        let selectedEmployee = new MyleDSQEmployeeResponse();
        selectedEmployee.LastName = employee.LastNameDSQ;
        selectedEmployee.FirstName = employee.FirstNameDSQ;
        selectedEmployee.LicenceNumber = employee.LicenceDSQ;
        selectedEmployee.LicenceRoot = employee.LicenceRoot;
        selectedEmployee.NUI = employee.NUI;

        let requestData = {
            Employee: selectedEmployee,
            ContactFacetId: self.props.employeeModel.ContactFacet_id
        };

        let s = new DSQEmployeeComponentState();
        s.isLoading = true;
        self.setState(s);

        Client.PostDSQ(
            ServerOperations.Server.DSQ_SynchroniseEmployee,
            requestData,
            response => {
                let s = new DSQEmployeeComponentState();
                s.isLoading = false;

                if (response.Errors.length == 0) {
                    // Sync was a success. We return only one employee
                    if (response.Employees != null && response.Employees.length > 0) {
                        let dsqEmployee = response.Employees.firstOrDefault();
                        let myleEmployee = new Employee();

                        myleEmployee.FirstNameDSQ = dsqEmployee.FirstName;
                        myleEmployee.LastNameDSQ = dsqEmployee.LastName;
                        myleEmployee.LicenceDSQ = dsqEmployee.LicenceNumber;
                        myleEmployee.LicenceRoot = dsqEmployee.LicenceRoot;
                        myleEmployee.NUI = dsqEmployee.NUI;

                        self.props.updateEmployeeCallback(myleEmployee);
                    }
                }

                self.setState(s);
            },
            error => {
                let s = new DSQEmployeeComponentState();
                s.isLoading = false;
                self.setState(s);
                console.error(error);
            }
        );
    }

    // get employee type by licence root
    private getEmployeeType(root: string): string {
        let type = "";

        switch (root) {
            case "2.16.840.1.113883.4.288": // Collège des médecins du Québec"
                type = "0";
                break;

            case "2.16.840.1.113883.4.298": // Ordre des pharmaciens du Québec
                type = "1";
                break;

            case "2.16.840.1.113883.4.299": // Ordre des optométristes du Québec
                type = "2";
                break;

            case "2.16.840.1.113883.4.300": // Ordre des podiatres du Québec
                type = "3";
                break;

            case "2.16.840.1.113883.4.301": // Ordre des sages-femmes du Québec
                type = "4";
                break;

            case "2.16.840.1.113883.4.302": // Ordre des dentistes du Québec
                type = "5";
                break;

            case "2.16.840.1.113883.4.303": // "Ordre des infirmières et infirmiers du Québec
                type = "6";
                break;

            case "2.16.124.10.101.1.60.202": // "Infirmière et infirmier auxiliaire du Québec
                type = "7";
                break;
        }

        return type;
    }
}

export { DSQEmployeeComponent };
